import axios from "../../axiosInstance/axiosInstance";
import apiUrlOne from "../../utils.js/Config";

// Atmosphere APIs
export const getAtmospheres = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/atmospheres/get-all-atmospheres-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createAtmosphere = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/atmospheres`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateAtmosphere = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/atmospheres/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAtmosphereById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/atmospheres/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteAtmosphere = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/atmospheres/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Features APIs
export const getAllFeatures = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/features`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createFeature = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/features`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateFeature = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/features/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFeatureById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/features/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteFeature = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/features/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Packages APIs
export const getRetreatPackages = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/packages`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createRetreatPackage = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/packages`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateRetreatPackage = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/packages/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteRetreatPackage = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/packages/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Not Include Packages APIs
export const getRetreatNotIncludePackages = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/not-include-packages`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createRetreatNotIncludePackage = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/not-include-packages`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getRetreatNotIncludePackageById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/not-include-packages/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateRetreatNotIncludePackage = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/not-include-packages/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteRetreatNotIncludePackage = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/not-include-packages/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Facilities APIs
export const getFacilities = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/facilities/get-all-facilities-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createFacility = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/facilities`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFacilityById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/facilities/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateFacility = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/facilities/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteFacility = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/facilities/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Surrounding Areas APIs
export const getSurroundingAreas = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/surrounding-areas/get-all-surrounding-areas-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createSurroundingArea = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/surrounding-areas`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getSurroundingAreaById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/surrounding-areas/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateSurroundingArea = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/surrounding-areas/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteSurroundingArea = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/surrounding-areas/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Facilities Options APIs
export const getFacilitiesOptions = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/facilities-options/get-all-facilities-options`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createFacilitiesOption = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/facilities-options`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFacilitiesOptionById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/facilities-options/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateFacilitiesOption = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/facilities-options/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteFacilitiesOption = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/facilities-options/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Things in Area APIs
export const getThingsInArea = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/things-in-area/get-all-things-in-area-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createThingsInArea = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/things-in-area`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getThingsInAreaById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/things-in-area/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateThingsInArea = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/things-in-area/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteThingsInArea = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/things-in-area/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Airports APIs
export const getAirports = async (page = 1, limit = 10, search = '') => {
    try {
        let url = `${apiUrlOne}/airports/get-all-airports-admin?page=${page}`;
        if (limit !== undefined && limit !== 10) {
            url += `&limit=${limit}`;
        }
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createAirport = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/airports`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAirportById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/airports/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateAirport = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/airports/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteAirport = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/airports/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Visibility Plans APIs
export const getVisibilityPlans = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/visibility-plans/get-all-visibility-plans-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createVisibilityPlan = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/visibility-plans`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getVisibilityPlanById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/visibility-plans/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateVisibilityPlan = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/visibility-plans/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteVisibilityPlan = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/visibility-plans/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Addons APIs
export const getAllAddons = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/addons/get-all-addons-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createAddon = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/addons`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateAddon = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/addons/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAddon = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/addons/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteAddon = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/addons/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Meals APIs
export const getAllMeals = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/meals/get-all-meals-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createMeal = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/meals`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateMeal = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/meals/${id}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getMeal = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/meals/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteMeal = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/meals/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Drinks APIs
export const getAllDrinks = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/drinks/get-all-drinks-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createDrink = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/drinks`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateDrink = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/drinks/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getDrink = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/drinks/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteDrink = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/drinks/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Diet Options APIs
export const getAllDietOptions = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/diet-options/get-all-diet-options-admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createDietOption = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/diet-options`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateDietOption = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/diet-options/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getDietOption = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/diet-options/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteDietOption = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/diet-options/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Visibility Factors APIs
export const getVisibilityFactors = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/visibility-factors`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createVisibilityFactor = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/visibility-factors`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateVisibilityFactor = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/visibility-factors/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteVisibilityFactor = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/visibility-factors/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};